define.alias("shared/utils/upgrade/choose-your-upgrade", "calendar/utils/upgrade/choose-your-upgrade");